import TemplateView from '../../../../TemplateView'
import AssignAllMenu from './AssignAllMenu'
import AssignAllMenuButton from './AssignAllMenuButton'
import WordsFilter from '../WordsFilter'
import OnlyActiveSwitch from './OnlyActiveSwitch'
import Switcher from '../../../../components/Switcher'
import {isNotEmptyString} from '../../../../util/StringUtils'
import {getInstance as assignmentsTooltip} from '../../../../SimpleSingletonTooltip'

export default class EntitiesListHeader extends TemplateView {
    constructor({
        title = "",
        nameColumnHeaderTitle = "",
        countersColumnHeaderTitle = "",
        assignAllLabel = "",
        unassignAllLabel = "",
        showOnlyActiveSwitch = false,
        onlyActiveSelectedText = '',
        allStatusesSelectedText = '',
        onAssignAll = () => {},
        onUnassignAll = () => {},
        onOnlyActiveChanged = onlyActive => {},
        onChangeExistingAndFutureAssignment = assigned => {},
        onSearchTextChanged = text => {},
        hideSearch = () => {},
        titleMessageSwitcher = '',
        additionalClass = '',
        workAssignmentsVisible = false,
        managementAssignmentsEditable = false,
    }) {
        super()

        this.params = {
            title,
            nameColumnHeaderTitle,
            countersColumnHeaderTitle,
            assignAllLabel,
            unassignAllLabel,
            showOnlyActiveSwitch,
            onlyActiveSelectedText,
            allStatusesSelectedText,
            titleMessageSwitcher,
            additionalClass,
            workAssignmentsVisible,
            managementAssignmentsEditable,
        }

        this.callbacks = {
            onAssignAll,
            onUnassignAll,
            onOnlyActiveChanged,
            onSearchTextChanged,
            hideSearch,
            onChangeExistingAndFutureAssignment
        }

        this.state = {
            futureAssigned: false,
            allAssigned: false,
            someAssigned: false,
            onlyActive: false,
            searchOpen: false,
            searchText: '',
            changingAllAssignments: false,
            disabledSwitcherTooltipText: '',
            disabledCheckboxTooltipText: '',
            listIsEmpty: false,
            isAssignAllCheckboxDisabled: false,
        }

        this.onAnyStatePropertyChanged(['allAssigned', 'someAssigned'], state => {
            this.assignAllButton.setState({
                checked: state.allAssigned,
                indeterminate: state.someAssigned
            })
        })

        this.onStatePropertyChanged('onlyActive', onlyActive => {
            if (this.onlyActiveSwitch) {
                this.onlyActiveSwitch.setState({
                    onlyActive: onlyActive
                })
            }
        })

        this.onAnyStatePropertyChanged(['searchOpen', 'searchText', 'listIsEmpty'], state => {
            this.wordsFilter.setState({
                open: state.searchOpen,
                text: state.searchText,
                disabled: state.listIsEmpty,
            })
        })

        this.onStatePropertyChanged('futureAssigned', futureAssigned => {
            if (this.allExistingAndFutureSwitcher) {
                this.allExistingAndFutureSwitcher.setState({
                    enabled: futureAssigned,
                })
            }
        })

        this.onAnyStatePropertyDeeplyChanged(['disabledCheckboxTooltipText', 'isAssignAllCheckboxDisabled'], state => {
            this.assignAllButton.setState({
                disabled: state.isAssignAllCheckboxDisabled,
            })

            this.unsubscribeAssignAllTooltip && this.unsubscribeAssignAllTooltip()
            if (state.isAssignAllCheckboxDisabled) {
                this._createTooltipOnAllAssignButton(state.disabledCheckboxTooltipText)
            }
        })

        this.onStatePropertyChanged('disabledSwitcherTooltipText', text => {
            if (this.allExistingAndFutureSwitcher) {
                this.allExistingAndFutureSwitcher.setState({
                    readOnly: !!text,
                })

                this.unsubscribeAllExistingAndFutureTooltip && this.unsubscribeAllExistingAndFutureTooltip()
                if (text) {
                    this.unsubscribeAllExistingAndFutureTooltip = assignmentsTooltip().subscribeToMouseEvents(
                        this.allExistingAndFutureSwitcher.getEl(),
                        () => assignmentsTooltip().setState({
                            text,
                            extraClass: 'hierarchyAssignmentsTooltip',
                        })
                    )
                }
            }
        })
    }

    templateHtml() {
        return "<div class='entitiesListHeader'>" +
               "  <div class='mainHeaderContainer'>" +
               "    <div class='title'><%-params.title%></div>" +
               "    <div class='allExistingFuturesBlock'>" +
               "        <div class='allExistingFuturesSwitcher'></div>" +
               "        <div class='allExistingFuturesText'><%-params.titleMessageSwitcher%></div>" +
               "    </div>" +
               "  </div>" +
               "  <div class='columnHeaders'>" +
               "    <div class='searchFieldArea'>" +
               "      <div class='columnHeader allAssignedSelectorContainer'></div>" +
               "      <div class='columnHeader nameColumnHeader'>" +
               "        <div class='nameColumnHeaderTitle'><%-params.nameColumnHeaderTitle%></div>" +
               "      </div>" +
               "      <div class='wordsFilterPlaceholder'></div>" +
               "    </div>" +
               "    <%if (params.showOnlyActiveSwitch) {%>" +
               "      <div class='separator'></div>" +
               "      <div class='onlyActiveSwitchPlaceholder'></div>" +
               "    <%}%>" +
               "    <%if (params.countersColumnHeaderTitle) {%>" +
               "      <div class='columnHeader countersColumnHeader'><%-params.countersColumnHeaderTitle%></div>" +
               "     <%}%>" +
               "  </div>" +
               "</div>"
    }

    afterRender() {
        this.$allAssignedSelectorContainer = this.find('.allAssignedSelectorContainer')

        this.assignAllMenu = new AssignAllMenu({
            assignAllLabel: this.params.assignAllLabel,
            unassignAllLabel: this.params.unassignAllLabel,
            onAssignAll: () => this.callbacks.onAssignAll(),
            onUnassignAll: () => this.callbacks.onUnassignAll()
        }).init(this.$allAssignedSelectorContainer)

        this.assignAllButton = new AssignAllMenuButton({
            additionalClass: this.params.additionalClass,
            onClick: () => this.assignAllMenu.showAt(this.assignAllButton.getEl())
        }).init(this.$allAssignedSelectorContainer)

        if (this.params.showOnlyActiveSwitch) {
            this.onlyActiveSwitch = new OnlyActiveSwitch({
                onlyActiveSelectedText: this.params.onlyActiveSelectedText,
                allStatusesSelectedText: this.params.allStatusesSelectedText,
                onChanged: onlyActive => this.callbacks.onOnlyActiveChanged(onlyActive)
            }).init(this.find('.onlyActiveSwitchPlaceholder'))
        }

        this.wordsFilter = new WordsFilter({
            onChange: text => this.callbacks.onSearchTextChanged(text),
            onHide: () => this.callbacks.hideSearch(),
        }).init(this.find('.wordsFilterPlaceholder'))

        this.$allExistingFuturesSwitcher = this.find('.allExistingFuturesSwitcher')
        if(isNotEmptyString(this.params.titleMessageSwitcher)) {
            this.allExistingAndFutureSwitcher = new Switcher({
                additionalClass: 'small',
                onSwitchCallback: (enabled) => this.callbacks.onChangeExistingAndFutureAssignment(enabled),
            }).init(this.$allExistingFuturesSwitcher)
        }
    }

    _createTooltipOnAllAssignButton() {
        this.unsubscribeAssignAllTooltip = assignmentsTooltip().subscribeToMouseEvents(
            this.assignAllButton.getEl(),
            () => assignmentsTooltip().setState({
                text: this.state.disabledCheckboxTooltipText,
                extraClass: 'hierarchyAssignmentsTooltip',
            })
        )
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/EntitiesListHeader.js